import { ReactComponent as PandoraColorLight } from 'fym-shared/src/music-services/assets/images/pandora-color-light.svg';
import { ReactComponent as PandoraColorDark } from 'fym-shared/src/music-services/assets/images/pandora-color-dark.svg';
import { ReactComponent as PandoraColorLightPadding } from 'fym-shared/src/music-services/assets/images/pandora-color-light-padding.svg';
import { ReactComponent as PandoraColorDarkPadding } from 'fym-shared/src/music-services/assets/images/pandora-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const pandoraImages: MusicServiceImages = {
  logoColor: {
    light: PandoraColorLight,
    dark: PandoraColorDark,
  },
  logoColorPadding: {
    light: PandoraColorLightPadding,
    dark: PandoraColorDarkPadding,
  },
};
